export const retroQuestionTemplates = {
  "What Went Well, What Didn't Go Well": {
    name: "What Went Well, What Didn't Go Well",
    value: ['What Went Well', "What Didn't Go Well"],
  },
  'Mad, Sad, Glad': {
    name: 'Mad, Sad, Glad',
    value: ['Mad', 'Sad', 'Glad'],
  },
  'Start, Stop, Continue': {
    name: 'Start, Stop, Continue',
    value: ['Start', 'Stop', 'Continue'],
  },
  'Went Well, To Improve, Action Items': {
    name: 'Went Well, To Improve, Action Items',
    value: ['Went Well', 'To Improve', 'Action Items'],
  },
  'To Dicuss, Discussing, Discussed': {
    name: 'To Dicuss, Discussing, Discussed',
    value: ['To Dicuss', 'Discussing', 'Discussed'],
  },
  '4L': {
    name: '4L',
    value: ['Liked', 'Learned', 'Lacked', 'Longed For'],
  },
  Sailboat: {
    name: 'Sailboat',
    value: [
      'What is the wind pushing our sails that make us go fast',
      'What anchors are holding us back',
      'What rocks are ahead of us that risk our future',
      'What is our ideal island destination',
    ],
  },
  '3 Little Pigs': {
    name: '3 Little Pigs',
    value: ['House of Straws', 'House of Sticks', 'House of Bricks'],
  },
  'Speed car - Engine': {
    name: 'Speed car - Engine',
    value: [
      'What make us move faster?',
      'Parachute - What is slowing us down?',
    ],
  },
  'Six Thinking Hats': {
    name: 'Six Thinking Hats',
    value: [
      'Green Hat',
      'Blue Hat',
      'White Hat',
      'Red Hat',
      'Black Hat',
      'Yellow Hat',
    ],
  },
  'Keep, Add, Less, More': {
    name: 'Keep, Add, Less, More',
    value: ['Keep', 'Add', 'Less', 'More'],
  },
  'Drop, Add, Keep, Improve': {
    name: 'Drop, Add, Keep, Improve',
    value: ['Drop', 'Add', 'Keep', 'Improve'],
  },
  'Strengths, Weaknesses, Opportunities, Threats': {
    name: 'Strengths, Weaknesses, Opportunities, Threats',
    value: ['Strengths', 'Weaknesses', 'Opportunities', 'Threats'],
  },
  'Explorer, Shopper, Vacationer, Prisoner': {
    name: 'Explorer, Shopper, Vacationer, Prisoner',
    value: ['Explorer', 'Shopper', 'Vacationer', 'Prisoner'],
  },
  'Mistakes, Experiments, Practices, Learnings': {
    name: 'Mistakes, Experiments, Practices, Learnings',
    value: ['Mistakes', 'Experiments', 'Practices', 'Learnings'],
  },
  'We Do, We Value': {
    name: 'We Do, We Value',
    value: ['We Do', 'We Value'],
  },
  'Love, Want, Hate, Learn': {
    name: 'Love, Want, Hate, Learn',
    value: ['Love', 'Want', 'Hate', 'Learn'],
  },
  'Good, Bad, Better, Best': {
    name: 'Good, Bad, Better, Best',
    value: ['Good', 'Bad', 'Better', 'Best'],
  },
  'Key Results, Initiatives, Objectives': {
    name: 'Key Results, Initiatives, Objectives',
    value: ['Key Results', 'Initiatives', 'Objectives'],
  },
  'Happy, Meh, Sad': {
    name: 'Happy, Meh, Sad',
    value: ['Happy', 'Meh', 'Sad'],
  },
  'Rose, Bud, Thorn': {
    name: 'Rose, Bud, Thorn',
    value: ['Rose', 'Bud', 'Thorn'],
  },
  'Hopes, Fears': {
    name: 'Key Results, Initiatives, Objectives',
    value: ['Hopes, Fears'],
  },
};
